var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluGreenPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#30B0C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.998H18V23.998H16V17.998H10V15.998H16V9.99805H18V15.998H24V17.998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluGreenPlus);
export default __webpack_public_path__ + "static/media/bluGreenPlus.7742d51956e03ab9a582e47676ade252.svg";
export { ForwardRef as ReactComponent };